import styled from "styled-components";
import { SecondaryButtonAtom } from "../Buttons/Generic/SecondaryButton";
import { CurrentLanguageType, useSettingsStorageContext } from "../ContextLayer/SettingsStorageProvider";

const LanguageSwitchAtom = styled.div<{$darkMode: boolean}>`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: rgba(255, 255, 255, ${props => props.$darkMode ? '0.2' : '0.40'});
    border-radius: 100px;
    padding: 3px;
`

const LanguageSwitchItemAtom = styled(SecondaryButtonAtom)<{$current?: boolean, $darkMode: boolean}>`
    width: 30px;
    height: 30px;
    font-size: 0.8rem;
    font-weight: 600;
    color: rgba(${props => props.$darkMode ? '254, 247, 226' : '16, 16, 16'}, ${props => props.$current ? '1' : '0.5'});
    background-color: rgba(255, 255, 255, ${props => props.$current ? props.$darkMode ? '0.4' : '0.8' : '0'});
    transition: color var(--transition-duration-normal), background var(--transition-duration-normal);

    &:hover {
        color: rgba(16, 16, 16, ${props => props.$current ? '1' : '0.8'});
        background-color: rgba(255, 255, 255, ${props => props.$current ? '1' : '0.3'});
    }
`

type LanguageSwitchProps = {

}

export default function LanguageSwitch(props: LanguageSwitchProps) {
    const { settings, setSettings} = useSettingsStorageContext();
    const switchLanguage = (e: React.MouseEvent) => {
        const newValue = (e.target as HTMLDivElement).id as CurrentLanguageType;
        if(newValue === settings.currentLanguage) return;
        localStorage.setItem('vocabularyTrainerMode', newValue);
        setSettings({
            ...settings,
            currentLanguage: newValue
        });
    }

    return (
        <LanguageSwitchAtom $darkMode={settings.darkMode}>
            <LanguageSwitchItemAtom id="foreign" $darkMode={settings.darkMode} $current={settings.currentLanguage === 'foreign'} onClick={switchLanguage}>IT</LanguageSwitchItemAtom>
            <LanguageSwitchItemAtom id="native" $darkMode={settings.darkMode} $current={settings.currentLanguage === 'native'} onClick={switchLanguage}>EN</LanguageSwitchItemAtom>
        </LanguageSwitchAtom>
    )
}